import { useQuery, UseQueryResult } from '@tanstack/react-query'

import { Location } from '@core/api/entities/location'
import { LocationMapper } from '@core/api/mappers/locationMapper'
import { locationService } from '@core/api/services/locationService'

import { DEFAULT_PARAMS } from './common'

export const useLocationByUUID = ({
	uuid,
	config,
	options,
}: any = DEFAULT_PARAMS): UseQueryResult<Location, Error> => {
	const QUERY_KEY = [
		'location',
		'uuid',
		uuid,
		{
			...config?.params,
		},
	]

	return useQuery({
		queryKey: QUERY_KEY,
		queryFn: () =>
			locationService
				.getLocationByUUID(uuid, config)
				.then(({ data: response }) => {
					return LocationMapper.toEntity(response.data)
				}),
		...options,
	})
}
